import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './LandingPage.css';
import heroImage from '../assets/hero-image.svg'; // Bu resmi assets klasörüne ekleyeceğiz

const LandingPage = () => {
    const { t } = useTranslation();

    return (
        <div className="landing-page">
            {/* 1. Hero Section */}
            <section className="hero-section">
                <div className="hero-content">
				 <span className="hero-badge">{t('hero_badge')}</span>
                    <h1>{t('hero_title')}</h1>
                    <p>{t('hero_description')}</p>
                    <div className="hero-buttons">
                        <Link to="/order" className="cta-button primary">{t('calculate_price_btn')}</Link>
                    </div>
                </div>
                <div className="hero-image-container">
                    <img src={heroImage} alt="Global Translation" />
                </div>
            </section>

        {/*
  <section className="trusted-by-section">
                <p>{t('trusted_by')}</p>
                <div className="logos">
                    <span><i className="fab fa-amazon"></i> Amazon</span>
                    <span><i className="fab fa-google"></i> Google</span>
                    <span><i className="fab fa-spotify"></i> Spotify</span>
                    <span><i className="fab fa-airbnb"></i> Airbnb</span>
                    <span><i className="fab fa-microsoft"></i> Microsoft</span>
                </div>
            </section>  */}

             <section className="how-it-works-section">
                <h2>{t('how_it_works_title', '3 Adımda Kolay Çeviri')}</h2>
                <div className="steps-container">
                    <div className="step-card">
                        <div className="step-icon"><i className="fas fa-upload"></i></div>
                        <h3>{t('step1_title_how', '1. Belgeni Yükle')}</h3>
                        <p>{t('step1_desc_how', 'Dosyanızı veya metninizi sisteme güvenle yükleyin.')}</p>
                    </div>
                    <div className="step-card">
                        <div className="step-icon"><i className="fas fa-calculator"></i></div>
                        <h3>{t('step2_title_how', '2. Anında Fiyat Al')}</h3>
                        <p>{t('step2_desc_how', 'Kelime sayısı ve dil seçeneklerinize göre anında şeffaf fiyatlandırma.')}</p>
                    </div>
                    <div className="step-card">
                        <div className="step-icon"><i className="fas fa-flag-checkered"></i></div>
                        <h3>{t('step3_title_how', '3. Çevirin Hazır!')}</h3>
                        <p>{t('step3_desc_how', 'Uzman çevirmenlerimiz tarafından hazırlanan belgenizi zamanında teslim alın.')}</p>
                    </div>
                </div>
            </section>

            <section className="services-section-creative">
                <div className="section-header">
                    <span className="section-subtitle">{t('our_services_subtitle')}</span>
                    <h2>{t('our_services_title')}</h2>
                </div>
                <div className="services-grid-creative">
                    <div className="service-card-creative"><i className="fas fa-gavel"></i><h3>{t('legal')}</h3><p>{t('legal_desc')}</p></div>
                    <div className="service-card-creative"><i className="fas fa-stethoscope"></i><h3>{t('medical')}</h3><p>{t('medical_desc')}</p></div>
                    <div className="service-card-creative"><i className="fas fa-cogs"></i><h3>{t('technical')}</h3><p>{t('technical_desc')}</p></div>
                    <div className="service-card-creative"><i className="fas fa-book-open"></i><h3>{t('academic')}</h3><p>{t('academic_desc')}</p></div>
                </div>
            </section>

            <section className="final-cta-section-creative">
                <div className="cta-content">
                    <h2>{t('final_cta_title')}</h2>
                    <p>{t('final_cta_desc')}</p>
                    <Link to="/order" className="cta-button primary large">{t('get_instant_quote')}</Link>
                </div>
            </section>
        </div>
    );
};

export default LandingPage;